<template>
  <div class="container footer">
    <hr>
    <div class="small">
      <div v-if="nome_fantasia">{{nome_fantasia}} - {{ ano }}. Todos os direitos reservados.</div>
      <div class="mb-2" v-if="full">
        <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termo de uso</a>
        <i class="i-point mx-2"></i>
        <a href="https://parceiros.lecard.delivery/politica-privacidade" target="_blank" class="text-primary font-weight-bold">Política de Privacidade</a>
        <i class="i-point mx-2"></i>
        <span>Versão {{ app_version }}</span>
      </div>
    </div>
    <div class="mt-2">
      <a href="https://www.lecard.delivery/" target="_blank" class="text-primary">
        <icon-lecard/>
      </a>
    </div>
  </div>
</template>

<script>
  import CardInfo from './CardInfo'
  import IconLecard from "./IconLecard";

  export default {
    name: "AdsLeCard",
    props: ['full'],
    components: {IconLecard, CardInfo},
    data() {
      const date = new Date();
      return {
        nome_fantasia: '',
        ano: date ? date.getFullYear() : '2024'
      }
    },
    computed: {
      empresa() {
        return this.$store.state.empresa;
      }
    },

    mounted() {
      this.nome_fantasia = this.empresa.nome_fantasia || process.env.VUE_APP_TITLE || '';
    }
  }
</script>

<style scoped>
.footer {
  text-align: center;
  margin-top: 32px;
}
</style>
